import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { acknowledgeAlert, AlertRecord, listAlerts, resolveAlert } from "../api";

export function AlertsPage() {
  const { t, i18n } = useTranslation(["dashboard", "common"]);
  const [alerts, setAlerts] = useState<AlertRecord[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  async function refresh() {
    try {
      const list = await listAlerts();
      setAlerts(list);
      setError(null);
    } catch (exc) {
      setError(String(exc));
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    refresh();
    const id = window.setInterval(refresh, 10000);
    return () => window.clearInterval(id);
  }, []);

  async function onAck(eventId: string) {
    await acknowledgeAlert(eventId);
    refresh();
  }

  async function onResolve(eventId: string) {
    await resolveAlert(eventId);
    refresh();
  }

  if (loading) return <p>{t("common:actions.loading")}</p>;
  if (error) return <p className="error">{error}</p>;
  if (alerts.length === 0) return <p>{t("alerts.empty")}</p>;

  return (
    <table className="alerts">
      <thead>
        <tr>
          <th>{t("alerts.th.time")}</th>
          <th>{t("alerts.th.vehicle")}</th>
          <th>{t("alerts.th.code")}</th>
          <th>{t("alerts.th.summary")}</th>
          <th>{t("alerts.th.severity")}</th>
          <th>{t("alerts.th.status")}</th>
          <th>{t("alerts.th.action")}</th>
        </tr>
      </thead>
      <tbody>
        {alerts.map((a) => (
          <tr key={a.event_id} className={`severity-${a.severity}`}>
            <td>{new Date(a.occurred_at).toLocaleString(i18n.resolvedLanguage)}</td>
            <td>{a.vehicle_id}</td>
            <td>{a.code}</td>
            <td>{a.summary}</td>
            <td>{a.severity}</td>
            <td>{a.status}</td>
            <td>
              {a.status === "open" && (
                <button type="button" onClick={() => onAck(a.event_id)}>
                  {t("alerts.ack")}
                </button>
              )}
              {a.status !== "resolved" && (
                <button type="button" onClick={() => onResolve(a.event_id)}>
                  {t("alerts.resolve")}
                </button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
